module.exports = __webpack_public_path__ + "img/sxf.3dd73428.png";